import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ItemService, RoutingHistoryService } from '../services';
import { ItemEditContextModel } from '../services/item.service';
import * as _ from 'lodash';

@Component({
    template: `
        <mat-toolbar color="primary">
            <app-nav></app-nav>
            <span fxFlex></span>
            <logo></logo>
            <span fxFlex></span>
            <create-topic-link></create-topic-link>
            <app-right-nav></app-right-nav>
        </mat-toolbar>
        <mat-sidenav-container>
            <mat-sidenav-content>
                <mat-toolbar>
                    <span fxFlex></span>
                    <button  mat-button class="menu-button" (click)="cancel()"><i class="big-icon fa fa-times"></i></button>
                </mat-toolbar>
                <router-outlet></router-outlet>
            </mat-sidenav-content>
            <mat-sidenav [autoFocus]="false" mode="over" position="end" #rightSideNav (closedStart)="closingTime()">
                <item-viewer *ngIf="focusedItemContext" 
                             [itemContext]="focusedItemContext"
                             [curating]="focusedItemContext?.isCuration"
                             (close)="close()"></item-viewer>
                <div *ngIf="focusedItemEditContext">
                    <item-post [itemEditContextModel]="focusedItemEditContext" (done)="close(100)"></item-post>
                </div>
            </mat-sidenav>
        </mat-sidenav-container>
    `
})
export class TopicsComponent implements OnInit, OnDestroy {
    @ViewChild('rightSideNav', { static: true }) rightSideNav;
    private cleanupTime = new Subject<void>();
    focusedItemContext: any;
    focusedItemEditContext: ItemEditContextModel;

    constructor(private router: Router, private itemService: ItemService, private routingHistoryService: RoutingHistoryService) {}
    
    ngOnInit(): void {
        this.itemService.focusedItemEdit.pipe(takeUntil(this.cleanupTime))
        .subscribe(context => {
            this.focusedItemEditContext = context;
            if (context) {
                this.rightSideNav?.open();
            } else {
                this.rightSideNav?.close();
            }
        });
        
        this.itemService.focusedItem.pipe(takeUntil(this.cleanupTime))
        .subscribe(item => {
            this.focusedItemContext = item;
            if (item) {
                this.rightSideNav.open();
            } else {
                this.rightSideNav.close();
            }
        });
    }

    close(): void {
        setTimeout(() => {
            this.rightSideNav.close();
        }, 1000);
    }

    closingTime(): void {
        this.itemService.itemClosing.next();
    }
    
    cancel(): void {
        if(this.routingHistoryService.getHistory().length > 1) {
            const reverseHistory = _.reverse(this.routingHistoryService.getHistory());
            this.router.navigateByUrl(_.find(reverseHistory, url => !url.startsWith('/login') && 
                                                                    !(url.startsWith('/settings') && !url.startsWith('/settings/topics')) &&
                                                                    !url.startsWith('/topics') &&
                                                                    !url.startsWith(this.router.url), 1) || '');
        } else {
            this.router.navigate(['/browse']);
        }
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}